import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addpromotion',
  template: require('./addpromotion.component.html'),
  styles: [],
})
export class AddPromotionComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
  }


}
